import React from "react";
import { Button } from "react-bootstrap";
import "../App.css";

export default function CustomButton({
  children,
  variant = "primary",
  onClick,
  type = "button",
  disabled = false,
  className = "",
  reportclassName = "",
  as,
  ...rest
}) {
  return (
    <Button
    as={as}
      type={as ? undefined : type}
      onClick={onClick}
      disabled={disabled}
      className={`btn btn-${variant} ${className} ${reportclassName}`}
      {...rest}
    >
      {children}
    </Button>
  );
}